const CATALOG = {
  CA: {
    plans: [
      {
        title: 'Basic',
        priceMonthly: 0,
        priceAnnual: 0,
        features: [
          'Barcharts: Overview & Details',
          'News',
          'Videos',
          'Messenger',
          'Unlimited Account Members',
        ],
        id: 'Basic-Plan',
      },
      {
        title: 'Smart Plan',
        priceMonthly: 300,
        priceAnnual: 3000,
        features: [
          'Includes Market Intelligence, PLUS',
          'Smart Advsior',
          'Price Finder',
          'Risk Profile',
          'Farm Profile',
          'Farm Wealth Tools : Scenario Planner, Cash Flow Planner, ROI Calculator',
          'Customer Experience',
          'Podcasts',
        ],
        id: 'Smart-Plan',
      },
      {
        title: 'Market Intelligence',
        priceMonthly: 150,
        priceAnnual: 1500,
        features: [
          'Includes Basic, PLUS',
          'FarmLink Publications',
          'DePutter Publications',
          'GrainFox Originals',
        ],
        id: 'Market-Intelligence-Plan',
      },
    ],
    addons: [],
    sinoa: [
      {
        id: 'Sinoa-Intro-Plan',
        title: 'Sinoa Intro Plan',
        questions: 100,
        price: 19.99,
      },
      {
        id: 'Sinoa-1200-Plan',
        title: 'Sinoa 1200 Plan',
        questions: 1200,
        price: 240,
      },
    ],
  },
  US: {
    plans: [
      {
        title: 'Basic',
        priceMonthly: null,
        priceAnnual: 0,
        features: [
          'Barcharts: Overview & Details',
          'News & Weather',
          'Videos',
          'Messenger',
          'Farm Profile',
        ],
        id: 'US-Basic',
      },
      {
        title: 'US Smart Plan',
        priceMonthly: null,
        priceAnnual: 2200,
        features: [
          'Includes Market Intelligence, PLUS',
          'Smart Advsior',
          'Price Finder',
          'Risk Profile',
          'Farm Profile',
          'Farm Wealth Tools : Scenario Planner, Cash Flow Planner, ROI Calculator',
          'Customer Experience',
          'Podcasts',
        ],
        id: 'US-Smart-Plan',
      },
      {
        title: 'US Market Intelligence Plan',
        priceMonthly: null,
        priceAnnual: 1850,
        features: [
          'Includes Basic, PLUS',
          'AgResource: Daily Research, Plus+ Research',
          'GrainFox Originals: Ag News Roundup',
          'Price Finder',
          'Farm Wealth Tools: Scenario Planner, Cash Flow Planner, ROI Calculator',
        ],
        id: 'US-Market-Intelligence',
      },
    ],
    addons: [
      {
        id: 'Weekly-Research',
        title: 'Add Weekly Research',
        priceAnnual: 2750,
        description:
          'The Weekly Research provided by AgResource with long term trends and worldwide analysis.',
      },
    ],
    sinoa: [
      {
        id: 'Sinoa-Intro-Plan',
        title: 'Sinoa Intro Plan',
        questions: 100,
        price: 19.99,
      },
      {
        id: 'Sinoa-1200-Plan',
        title: 'Sinoa 1200 Plan',
        questions: 1200,
        price: 240,
      },
    ],
  },
};

export default CATALOG;
